import { db } from '../config';
import { doc, setDoc, getDoc, updateDoc, arrayUnion, arrayRemove, serverTimestamp } from 'firebase/firestore';

export async function registerForCourse(userId: string, courseId: string) {
  const progressRef = doc(db, 'coursesprogress', `${userId}_${courseId}`);
  await setDoc(progressRef, {
    userId,
    courseId,
    registeredAt: serverTimestamp(),
    completedModules: [],
    notes: []
  }, { merge: true });
}

export async function markModuleComplete(userId: string, courseId: string, moduleId: string) {
  const progressRef = doc(db, 'coursesprogress', `${userId}_${courseId}`);
  await updateDoc(progressRef, {
    completedModules: arrayUnion(moduleId)
  });
}

export async function unmarkModuleComplete(userId: string, courseId: string, moduleId: string) {
  const progressRef = doc(db, 'coursesprogress', `${userId}_${courseId}`);
  await updateDoc(progressRef, {
    completedModules: arrayRemove(moduleId)
  });
}

export async function addNoteToCourse(userId: string, courseId: string, moduleId: string, text: string) {
  const progressRef = doc(db, 'coursesprogress', `${userId}_${courseId}`);
  const note = {
    id: Date.now().toString(),
    moduleId,
    text,
    timestamp: new Date().toISOString()
  };
  await updateDoc(progressRef, {
    notes: arrayUnion(note)
  });
}

export async function getCourseProgress(userId: string, courseId: string) {
  const progressRef = doc(db, 'coursesprogress', `${userId}_${courseId}`);
  const progressDoc = await getDoc(progressRef);
  return progressDoc.exists() ? progressDoc.data() : null;
} 